module.exports = __webpack_public_path__ + "static/img/200086.46092e86.png";